import React, { useState } from 'react';
 import emailjs from '@emailjs/browser'; // If using EmailJS

const Booking = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    service: '',
    date: '',
    time: '',
    message: ''
  });

  const [submitted, setSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError('');

    try {

      // For now, just log the data
      console.log('Booking form submitted:', formData);
      
      setSubmitted(true);
      
      // Clear form
      setFormData({
        name: '',
        email: '',
        service: '',
        date: '',
        time: '',
        message: ''
      });
      
    } catch (error) {
      console.error('Failed to submit booking:', error);
      setError('Failed to submit booking. Please try again or email us directly.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      {/* Hero Section */}
      <section className="page-hero">
        <div className="container">
          <h1>Book a Facilitator</h1>
          <p className="hero-cta">Book an experienced creative facilitator for workshops, 
            training sessions, and strategic conversations on creative development, 
            intellectual property, safeguarding, and inclusive artistic practice.</p>
        </div>
      </section>

      {/* Booking Form Section - Single Form Layout */}
      <section className="booking-section">
        <div className="container">
          <div className="booking-single-container">
            
            {/* Error Message */}
            {error && (
              <div className="error-message">
                {error}
              </div>
            )}
            
            {/* Success Message */}
            {submitted ? (
              <div className="success-message">
                <h3>Thank you for your booking request!</h3>
                <p>Your request has been sent successfully. We'll get back to you within 2-3 business days.</p>
                <button onClick={() => setSubmitted(false)} className="btn btn-secondary">
                  Book Another Session
                </button>
              </div>
            ) : (
              /* Booking Form */
              <form onSubmit={handleSubmit} className="booking-form-single">
                <h2 className="form-title">Request a Booking</h2>
                
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="name">Full Name *</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      disabled={isSubmitting}
                      placeholder="Enter your full name"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="email">Email Address *</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      disabled={isSubmitting}
                      placeholder="Enter your email address"
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="service">Type of Service *</label>
                  <select
                    id="service"
                    name="service"
                    value={formData.service}
                    onChange={handleChange}
                    required
                    disabled={isSubmitting}
                  >
                    <option value="">Select a service</option>
                    <option value="safeguarding">Safeguarding Session</option>
                    <option value="voice-acting">Voice Acting Project</option>
                    <option value="workshop">Workshop / Speaking Engagement</option>
                  </select>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="date">Preferred Date</label>
                    <input
                      type="date"
                      id="date"
                      name="date"
                      value={formData.date}
                      onChange={handleChange}
                      disabled={isSubmitting}
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="time">Preferred Time</label>
                    <input
                      type="time"
                      id="time"
                      name="time"
                      value={formData.time}
                      onChange={handleChange}
                      disabled={isSubmitting}
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="message">Message / Project Details</label>
                  <textarea
                    id="message"
                    name="message"
                    rows="5"
                    value={formData.message}
                    onChange={handleChange}
                    disabled={isSubmitting}
                    placeholder="Please share details about your project, requirements, or any specific questions..."
                  ></textarea>
                </div>

                <div className="form-actions">
                  <button 
                    type="submit" 
                    className="btn btn-large" 
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? 'Submitting...' : 'Submit Booking Request'}
                  </button>
                </div>

                <div className="form-footer">
                  <p>Prefer to email directly? <a href="mailto:habari@zirayainstitute.org">habari@zirayainstitute.org</a></p>
                </div>
              </form>
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default Booking;